import type { IconData } from '@stacksjs/iconify-core'

export const contentFilesFavoriteBook: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.715 1.52h-1.52v21.34H6.865v1.52h21.33v4.57h1.52zm-15.23 27.43h13.71v1.53h-13.71Z\"/><path fill=\"currentColor\" d=\"M16.005 18.29h4.57v1.52h-4.57ZM12.955 32v-4.57h13.72v-1.52H8.385v1.52h1.52v3.05h1.53V32zm0-16.76h10.67v1.52h-10.67Zm1.53-4.57h1.52v1.52h1.52v1.53h1.53v-1.53h1.52v-1.52h1.52V9.14h1.53V6.1h-1.53V4.57h-3.04V6.1h-1.53V4.57h-3.04V6.1h-1.53v3.04h1.53zm-7.62-7.62h1.52v18.28h-1.52ZM5.335 0h22.86v1.52H5.335Zm0 28.95h3.05v1.53h-3.05Zm0-4.57h1.53v1.53h-1.53ZM3.815 1.52h1.52v1.53h-1.52Z\"/><path fill=\"currentColor\" d=\"M3.815 3.05h-1.53v24.38h1.53v1.52h1.52v-3.04h-1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default contentFilesFavoriteBook
